import merge from 'lodash.merge'
import { NextRouter } from 'next/router'
import qs from 'qs'
import { SearchState } from 'react-instantsearch-core'

import { addonsFilterRefinement } from 'components/Filters/AddonsFilter/AddonsFilter'
import { categoryRefinement } from 'components/Filters/CategoryFilter/CategoryFilter'
import { priceFilterRefinement } from 'components/Filters/PriceBucketFilter/PriceBucketFilter'
import { priceRangeFilterRefinement } from 'components/Filters/PriceRangeFilter/PriceRangeFilter'
import { priceSortRefinement } from 'components/Filters/PriceSort/PriceSort'
import { ratingFilterRefinement } from 'components/Filters/RatingFilter/RatingFilter'
import { reviewsFilterRefinement } from 'components/Filters/ReviewsFilter/ReviewsFilter'

import { QueryOrSearchState, Refinement } from './types'

/**
 * Add refinements (filters, facets, or sorting options)
 * with capabilities of transforming from query param
 * to search state and vice-versa
 */
const REFINEMENTS: Refinement[] = [
  {
    getQueryParamValue: ({ query }) => query && { q: query },
    getStateValue: ({ q }) => ({ query: q || '' } as { query: string }),
  },
  categoryRefinement,
  priceFilterRefinement,
  priceRangeFilterRefinement,
  priceSortRefinement,
  addonsFilterRefinement,
  ratingFilterRefinement,
  reviewsFilterRefinement,
]

type TransformFunction = (refinement: Refinement) => QueryOrSearchState

const transform = (fn: TransformFunction) =>
  REFINEMENTS.map(fn).filter(Boolean).reduce(merge, {})

const queryParamsFrom = (searchState: SearchState): NextRouter['query'] =>
  transform((refinement) => refinement.getQueryParamValue(searchState))

const searchStateFrom = (query: NextRouter['query']): SearchState =>
  transform((refinement) => refinement.getStateValue(query))

const queryStringFrom = (searchState: SearchState): string =>
  qs.stringify(queryParamsFrom(searchState), {
    addQueryPrefix: true,
  })

export { queryStringFrom, searchStateFrom }
